import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';
import welcome from "./images/welcome.png"; 
import './home.css';

function Home() {
  const typedRef = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: ["A Frontend Developer", "An Image Editor", "A Video Editor"],
      typeSpeed: 60,
      backSpeed: 30,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div className="home-container" id="shoaib">
      <div className="wallpaper">
        <div className="overlay">
          <h1 className="main-name">Mohammed Shoaib</h1>
          <p className="sub-role">Frontend Developer</p>
          <span className="typed-text" ref={typedRef}></span>
        </div>
      </div>

      {/* Content Section */}
      <div className="content-section">
        <img className='welcome' src={welcome} alt="Welcome Logo" />
        <h2>WELCOME TO MY PORTFOLIO</h2>
        <p>I specialize in creating responsive and engaging UIs with modern web technologies.</p>
        <br /><br />
        <hr />
      </div>
    </div>
  );
}

export default Home;
